import { ComponentIds } from '@inter-ikea-core/core';
import {
  HelpLinesComponentVisible,
  HelpLinesComponentEditMode,
  ShapeTypeEnum,
  CoreApi,
  HelpLinesComponentShape
} from '@inter-ikea-storageone/range';
import { setAutofillActive } from 'rangeConfig/platsa/features/Autofill/Autofill';
import { setShape } from 'ducks/helpLines';
import { BehaviorParameters } from 'rangeConfig/@types';

/**
 * Enables optimize sapace feature if it deems is appropriate.
 * E.g. if there are no frames in scene if enables the feature.
 * It will also set the wall shape to default sqared if it currently
 * is set to off. But only if the feature should be turned on.
 * @param param0
 */
export const optimizeSpaceBehaviour = ({ coreApi, dispatch, rootState }: BehaviorParameters) => {
  const currentShape = rootState.helpLines.shape;
  const scene = coreApi.entities.getScene();

  const framesInScene = coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);
  if (framesInScene.length === 0) {
    scene?.addComponent(new HelpLinesComponentVisible(true));
    if (currentShape === ShapeTypeEnum.off) {
      scene?.addComponent(new HelpLinesComponentShape(ShapeTypeEnum.squared, []));
      dispatch(setShape(ShapeTypeEnum.squared));
      dispatch(setAutofillActive(true));
    }
  }
  scene?.addComponent(new HelpLinesComponentEditMode(true));
};

export const disableHelplineEditMode = ({ coreApi }: BehaviorParameters) => {
  const scene = coreApi.entities.getScene();
  scene?.addComponent(new HelpLinesComponentEditMode(false));
};

/**
 * Used by frames mainMenu groupEntered. Decides if and sets optimize space enabled.
 * If there are no frames in the scene optimize space is enabled. Otherwise we do nothing.
 */
export const enableHelplineEditMode = ({ coreApi, dispatch, rootState }: BehaviorParameters) => {
  const currentShape = rootState.helpLines.shape;
  const framesInScene = coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);

  if (framesInScene.length === 0) {
    const scene = coreApi.entities.getScene();
    scene?.addComponent(new HelpLinesComponentVisible(true)); // Set helplines visible
    scene?.addComponent(new HelpLinesComponentEditMode(true)); // Enable helplines edit mode
    // If no shape is set, default to square
    if (currentShape === ShapeTypeEnum.off) {
      dispatch(setShape(ShapeTypeEnum.squared));
      scene?.addComponent(new HelpLinesComponentShape(ShapeTypeEnum.squared, []));
      // Set UI toggle for enabling autofill to true
      dispatch(setAutofillActive(true));
    }
  }
};

/**
 * Used to show the optimize space tab when entering frames menu if there are no frames in the scene.
 * @param coreApi coreApi
 * @returns The tab index to be shown as default. 0 is normal frames tab. 1 is optimize space.
 */
export const showOptimizeSpaceTabWhenEnteringFrames = (coreApi: CoreApi): string => {
  const framesInScene = coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);
  return framesInScene.length === 0 ? 'frame-recommendations-tab' : 'frame-single-frames-tab';
};
